<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">PSM Administration</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="deleteSelected()" v-if="psm">Delete</a>
					<a href="#" @click="onLoad()" v-if="psm">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		
		<div class="row">
			<div class="col-md-3">
				<b-form-checkbox class="mb-2" v-model="hideDisabled">&nbsp; Hide Disabled</b-form-checkbox>
			</div>
			<div class="col-md-3">
				<b-form-checkbox class="mb-2" v-model="onlyArticles">&nbsp; Only CMS Moves</b-form-checkbox>
			</div>
			<div class="col-md-3">
				<b-form-checkbox class="mb-2" v-model="onlyAppScreen">&nbsp; Only App Screen Moves</b-form-checkbox>
			</div>
			<div class="col-md-3">
				<b-form-checkbox class="mb-2" v-model="onlyWeb">&nbsp; Only Web Moves</b-form-checkbox>
			</div>
		</div>

		<div v-for="(t, tagId) in tags" :key="t">
			<div style="clear:both" />
			<h3 class="mt-3">{{ t.charAt(0).toUpperCase() + t.substr(1).toLowerCase() }}
				<b-button v-if="!expand[tagId]" @click="expand[tagId] = true; $forceUpdate();" variant="outline" size="sm"><b-icon icon="arrows-expand"></b-icon></b-button>
				<b-button v-if="expand[tagId]" @click="expand[tagId] = false; $forceUpdate();" variant="outline" size="sm"><b-icon icon="arrows-collapse"></b-icon></b-button>
			</h3> 
			<b-collapse v-model="expand[tagId]">
				<div v-for="m in psms" :key="m.id" >
					<b-card v-if="(m.firstTag == t) && (m.enabled || !hideDisabled) && (m.cmsPage || !onlyArticles) && (m.appScreen || !onlyAppScreen) && (m.websiteUrl|| !onlyWeb)"  
						:style="(!m.enabled? 'opacity:0.3': '')"
						:title="m.name"
						:img-src="m.backgroundImage"
						img-alt="Image"
						img-top
						:tag="m.TagLine"
						style="float: left; max-width: 15rem; margin: 10px; font-size: 12px;"
						class="mb-2"
					>
						<b-card-text>
							<b-icon icon="exclamation-circle-fill" v-if="m.isAlsoNotification" variant="success"></b-icon>
							<b-icon icon="exclamation-circle-fill" v-if="m.isOnlyNotification" variant="warning"></b-icon>
							{{ m.description }}<br/>
							<code>
								{{ m.criteria }}
							</code>
						</b-card-text>
					</b-card>
				</div>
			</b-collapse>
		</div>

		
		<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Admin">
			<p class="my-4">{{message}}</p>
		</b-modal>

		<b-modal id="modSure" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Really?">
			<p class="my-4">Are you sure?</p>
			<template #modal-footer="{ ok, cancel }">
				<b-button variant="success" @click="doDeleteSelected()">Yes</b-button>
				<b-button variant="danger" @click="cancel()">No</b-button>
			</template>
		</b-modal>

	</div>
</div>
</template>
<script>

export default {
  name: 'AllPSMs',
  components: {
  },
  data() {
	return{
		message: null,
		error: null,
		criteria: null,
		search: "",
		psms: null,
		psm: null,
		hideDisabled: false,
		onlyArticles: false,
		onlyAppScreen: false,
		onlyWeb: false,
		tags: [],
		expand: []
	}
  },
  methods: {
	getPsms: function(){
		this.$http.get(this.$config.ApiUri + "/Moves")
			.then((result) => {
				this.psms = result.data;
				for (var x = 0; x< this.psms.length; x++)
				{
					this.expand.push(true);
					if (this.psms[x].websiteUrl == "") { this.psms[x].websiteUrl = null; }
					if (this.psms[x].appScreen == "") { this.psms[x].appScreen = null; }
					if (this.psms[x].cmsPage == "") { this.psms[x].cmsPage = null; }
					if (!this.psms[x].featureTags || this.psms[x].featureTags == "") { this.psms[x].featureTags = "Untagged"; }
					if (this.psms[x].featureTags && this.psms[x].featureTags != "")
					{
						this.psms[x].firstTag = this.psms[x].featureTags.split(',')[0];
						if (!this.tags.includes(this.psms[x].firstTag))
						{
							this.tags.push(this.psms[x].firstTag);
						}
					}
				}
			}
		)
	},
	selectPsm: function(p) {
		this.psm = p;
	},
	deleteSelected() {
		this.$bvModal.show('modSure');
	},
	doDeleteSelected() {
		this.$bvModal.hide('modSure');
		this.$http.delete(this.$config.ApiUri + "/Moves/" + this.psm.id)
			.then(() => {
				this.psm = null;
				this.getPsms(true);
				this.showMessage("PSM deleted OK!");
			}
		).catch((error) => { this.showError("Sorry, that PSM cannot be deleted.  This may mean moves have already been generated against it.  We cannot rewrite history. (" + error + ")"); });
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Tris"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 3000);
	},
	onLoad() {
		this.getPsms(true);
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>

h3 {
	font-size: 14px !important;
	font-weight: bold !important;
}

.card {
	border-radius: 10px !important;
}

.card-title {
	font-size: 13px;
	font-weight: bold;
}

.card-img-top {
	max-width: 100px;
	margin-right : auto;
	margin-left: auto;
	margin-top: 10px;
}

.filters
{
	margin-bottom: 10px;
	width: 100%;
}

.filters .btn-group
{
	width: 100%;
}

.modal-header .close {
  display:none;
}
#criteria .btn-sm {
	margin:3px;
	font-size:10px;
}
.actions-card {
	padding: 20px;
	margin-bottom: 10px;
	background-color:aliceblue;
}
.criteria-text
{
	font-family: monospace !important;
	color:white !important;;
	background-color: rgb(56, 56, 56) !important;;
}
</style>